 import { MeteringPointDirectionEnum } from '../misc/meteringPointDirectionEnum.js';

 /**
  * Check if the given direction is 'CONSUMPTION'.
  * @param direction {string} - The direction string to check.
  * @returns {boolean} - True if the direction is 'CONSUMPTION', false if it is 'GENERATION'.
  * @throws {Error} - If the direction is neither 'CONSUMPTION' nor 'GENERATION'. Especially for null or undefined.
  */
 export default function isConsumptionDirection(direction) {
      if (direction === MeteringPointDirectionEnum.CONSUMPTION) {
        return true;
      }
      if (direction === MeteringPointDirectionEnum.GENERATION) {
        return false;
      }
      // If direction is neither 'CONSUMPTION' nor 'GENERATION', throw an error.
      throw new Error(`Invalid metering point direction: ${direction}`);
  }
